import * as types from "../Action/type"
const initialState = {
  email: '',
  page: 'Email',
  submit: false,
  type:''
}


const ForgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_FORGET_REQUEST:
      return { ...state, submit: !state.submit };
    case types.FETCH_FORGET_SUCCESS:
      return { ...state, email: action.payload.email,type:action.payload.type, page: "ConfirmCode", submit: !state.submit };
    case types.FETCH_FORGET_FAIL:
      return { ...state, submit: !state.submit };

    case types.FETCH_CONFIRMATIONCODE_REQUEST:
      return { ...state, submit: !state.submit };
    case types.FETCH_CONFIRMATIONCODE_SUCCESS:
      return{...state,page:'newPasswordPage'};
      // return { ...state, page: "newPasswordPage", submit: !state.submit };
    case types.FETCH_CONFIRMATIONCODE_FAIL:
      return { ...state, submit: !state.submit };

    case types.FETCH_RESETPASSWORD_REQUEST:
      return { ...state, submit: !state.submit };
    case types.FETCH_RESETPASSWORD_SUCCESS:
      return { ...state, page: "Dashboard", submit: !state.submit };
    case types.FETCH_RESETPASSWORD_FAIL:
      return { ...state, submit: !state.submit };
    case types.BACK:
      return{...state,page:'email'};


    default:
      return state;
  }

}

export default ForgetReducer;
